export const useDocTitle = (titleValue: string) => {

  const title: HTMLTitleElement | null = document.querySelector('title');
  (title as HTMLTitleElement).innerText = titleValue
}